import { Input } from "@/components/ui/input";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { useState } from "react";

interface Member {
  firmName: string;
  area: string;
  jurisdiction: string;
  mobile: string;
  directorName: string;
}

const Members = () => {
  const [searchTerm, setSearchTerm] = useState("");

  // Example data - replace with actual data from your backend
  const members: Member[] = [
    {
      firmName: "Apollo Healthcare",
      area: "Vijayawada",
      jurisdiction: "Krishna District",
      mobile: "+91 9876543210",
      directorName: "Dr. Ramesh Kumar"
    },
    {
      firmName: "Care Hospitals",
      area: "Visakhapatnam",
      jurisdiction: "Visakhapatnam District",
      mobile: "+91 9876543211",
      directorName: "Dr. Suresh Reddy"
    },
    // Add more members as needed
  ];

  const filteredMembers = members.filter(member =>
    Object.values(member).some(value =>
      value.toLowerCase().includes(searchTerm.toLowerCase())
    )
  );

  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-4xl font-bold mb-6">MAAP Members Directory</h1>
      
      <div className="mb-6">
        <Input
          placeholder="Search members..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="max-w-sm"
        />
      </div>

      <div className="rounded-md border">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Firm Name</TableHead>
              <TableHead>Area</TableHead>
              <TableHead>Jurisdiction</TableHead>
              <TableHead>Mobile</TableHead>
              <TableHead>Director Name</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {filteredMembers.map((member, index) => (
              <TableRow key={index}>
                <TableCell className="font-medium">{member.firmName}</TableCell>
                <TableCell>{member.area}</TableCell>
                <TableCell>{member.jurisdiction}</TableCell>
                <TableCell>{member.mobile}</TableCell>
                <TableCell>{member.directorName}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
};

export default Members; 